import { AccountInfo, UserAccount, User } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { acceptTOSAction, replaceUserInAccountAction, setAccountsAction, setPrimaryAccountAction, setPortalAccountAction } from '../reducers/accountReducer';

export const useAccountActions = () => {

    const dispatch = useAppDispatch();

    const setPortalAccount = (account: AccountInfo) => {
        dispatch(setPortalAccountAction(account));
    }

    const setAccounts = (accounts: UserAccount[]) => {
        dispatch(setAccountsAction(accounts));
    }

    const setPrimaryAccount = (account: UserAccount) => {
        dispatch(setPrimaryAccountAction(account));
    }
        
    const clearAccounts = () => {
        dispatch(setAccountsAction([]));
    }

    const clearPrimaryAccount = () => {
        dispatch(setPrimaryAccountAction(undefined));
    }

    const replaceUserInAccount = (user: User) => {
        dispatch(replaceUserInAccountAction(user));
    }

    const acceptTOS = () => {
        dispatch(acceptTOSAction());
    }

    return { setPortalAccount, setAccounts, clearAccounts, setPrimaryAccount, clearPrimaryAccount, replaceUserInAccount, acceptTOS };
}
